module.exports = __webpack_public_path__ + "images/emoji/musical_note.295a5a02a0a9f0eff8aa.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/musical_note.png
// module id = +lPl
// module chunks = 13